<router-outlet></router-outlet>
<ngx-loading-bar color="#3F51B5" [includeSpinner]="false"></ngx-loading-bar>